<template>
  <gl-modal
    v-bind="$attrs"
    capitalize-title
    full-submit
    got-it-submit
    ok-only
    submit-title="Got it"
    title="Install Satoshi Eye on your device"
    v-on="$listeners"
    @submit="confirm"
  >
    <template #mainSlot>
      <div class="pwa-prompt-modal-wrapper">
        <template v-if="checkIfIos()">
          <div class="mb-3">
            <span class="mr-1">1.</span> In Safari, tap the <span class="pwa-prompt-modal__inner-test-bold mr-1">Share Button</span>
            <gl-icon
              class="pt-0-5"
              :height="20"
              name="pwa-share"
              :width="16"
            />.
          </div>
          <span>2.</span> In the menu that appears, select <span class="pwa-prompt-modal__inner-test-bold mr-1"><br>Add to Home Screen</span>
          <gl-icon
            class="pt-0-5"
            :height="20"
            name="pwa-add-to-home-screen"
            :width="16"
          />.
        </template>
        <template v-else>
          <div class="mb-3">
            <span class="mr-1">1.</span> In Chrome, tap the <span class="pwa-prompt-modal__inner-test-bold mr-1">More</span>
            <gl-icon
              class="pt-0-5"
              :height="18"
              name="I-S-More"
              :width="16"
            />
          </div>
          <span>2.</span> In the menu that appears, select <span class="pwa-prompt-modal__inner-test-bold mr-1"><br>Add to Home Screen</span>
          <gl-icon
            class="pt-0-5"
            :height="21"
            name="I-S-AddToHomeScreen"
            :width="18"
          />
        </template>
      </div>
    </template>
  </gl-modal>
</template>

<script>
// Components
import GlModal from '@/components/gl-modal'
import GlIcon from "@/components/gl-icon.vue";
// Vuex
import { mapState } from "vuex";
// Utils
import { checkIfIos } from "@/utils/pwa-support";

export default {
  components: {
    GlIcon,
    GlModal,
  },
  inheritAttrs: false,
  props: {
  },
  computed: {
    ...mapState('sidebar', ['isPromptOpen']),
  },
  methods: {
    checkIfIos,
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style>
.pwa-prompt-modal-wrapper {
  padding: 24px 13px 24px 24px;
  color: var(--Basic-800);
  font-weight: 500;
}

.pwa-prompt-modal-wrapper svg {
  display: inline-block;
}

.pwa-prompt-modal__inner-test-bold {
  color: var(--Basic-900);
  font-weight: 600;
}
</style>
